


















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

  @Component({
    components: {},
  })
  export default class StProgress extends Vue {
    @Prop() progress!: number;
    @Prop() badgeText!: string;
    @Prop() budgetMode!: boolean;

    private progressInternal: number = 0;

    @Watch('progress')
    changeProgress()
    {
      setTimeout(() => {
        this.progressInternal = this.progress > 100 ? 100 : this.progress;
      }, 10);
    }

    mounted()
    {
      setTimeout(() => {
        this.progressInternal = this.progress > 100 ? 100 : this.progress;
      }, 10);
    }

    get barClass() {
      if (!this.budgetMode) return {'good': true};

      if (this.progress <= 80) return {'good': true};
      if (this.progress > 80 && this.progress <= 95) return {'medium': true};
      if (this.progress > 95) return {'bad': true};
    }
  }
